import React, { useState } from "react";
import { Lock } from "react-feather";
import { SignInButton } from "../Buttons/SingnInButton";
import { EsqueciMinhaSenhaModal } from "../EsqueciMinhaSenhaModal";
import { Span, HelperSpan } from "./styles";
interface Props {
  type?: "Funcionario-Cartorio" | "Funcionario-Prefeitura" | "Cartorio";
}
export function RememberPassword({ type = "Cartorio" }: Props) {
    const[modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Span onClick={()=>setModalOpen(true)}>
        <HelperSpan>esqueci a senha</HelperSpan>
        <Lock size={"max(1.2vw, 14px)"} />
      </Span>
      <EsqueciMinhaSenhaModal open={modalOpen} onClose={()=>setModalOpen(false)} type={type}/>
      
    </>
  );
}
